import { api } from './api';

export const LS_TOKEN = 'jdqwh7sdawqe6';

export const setApiToken = (token) => {
  window.localStorage.setItem(LS_TOKEN, token);
  api.defaults.headers.common.Authorization = `Token ${token}`;
};

export const removeApiToken = () => {
  window.localStorage.removeItem(LS_TOKEN);
  delete api.defaults.headers.common.Authorization;
};
